import requestPassword from './request-password';
import startSSOWorkflow from './start-sso-workflow';

export default function configurePasswordServices() {
    return [requestPassword(), startSSOWorkflow()];
}
